import $ from 'jquery';

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle, .nav--header, .header__navigation').toggleClass('open');
    $('.header').toggleClass('menu-open');
    $('.nav-burger__line').toggleClass('menu-open');
    $('.header__container__logo__link__img-outer__img').toggleClass('show');
    $('.header__container__logo__link__img-outer__img').toggleClass('hide');
};

$('.js-menu-toggle').on('click', toggleMenu);

/**
 * Header Scroll Event
 * @param  {mixed} event
 */

 $(window).scroll(function(){
    var scroll = $(window).scrollTop();
    if (scroll >= 75) {
        $(".header, .nav-burger__line, .header__container__logo__link__img-outer__img").addClass("scrolled");
    } else {
        $(".header, .nav-burger__line, .header__container__logo__link__img-outer__img").removeClass("scrolled");
    }
});


// Accordion
$('.accordion-inner__list__item__title-holder').click(function(){
    $(this).toggleClass('open');
    $(this).closest('.accordion-inner__list__item').toggleClass('open');
    $(this).find('.accordion-inner__list__item__title-holder__toggle .toggle-icon').toggleClass('hide');
});